// Angular
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractModal } from '../../model/abstract.modal';
import { ModalButtonModel, ModalButtonType } from '../../model/modal-button.model';
import { ModalConfirmAction } from '../../model/modal.model';

@Component({
	selector: 'cv-modal-confirm',
	templateUrl: './modal-confirm.component.html'
})
export class ModalConfirmComponent extends AbstractModal implements OnInit {
	@Input() content: any;
	@Input() buttons: any;
	@Output() successEvent: EventEmitter<any> = new EventEmitter<any>();
	confirmLabel: string;
	confirmClass: string;

	ngOnInit(): void {
		const cancelButton: ModalButtonModel = {
			name: 'cancel',
			// icon: 'fa-ban',
			text: 'Cancel',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		const confirmButton: ModalButtonModel = {
			name: 'confirm',
			// icon: 'fa-check',
			text: this.data.confirmLabel || 'Confirm',
			class: 'btn-sm cv-btn-confirm ' + (this.data.confirmClass || ''),
			type: ModalButtonType.ACTION,
			action: this.onConfirm.bind(this)
		};
		this.buttons.push(cancelButton);
		this.buttons.push(confirmButton);
	}

	/**
	 * Close the Dialog by Confirm the Action
	 * @param result
	 */
	public onConfirm(): void {
		const data = {
			confirm: ModalConfirmAction.CONFIRM
		};
		super.onCancelClose(data);
	}

	/**
	 * Close the Dialog by Cancel/Close/Dismiss
	 * @param result
	 */
	public onCancel(): void {
		const data = {
			confirm: ModalConfirmAction.CANCEL
		};
		super.onCancelClose(data);
	}

	/**
	 * Abstract method that is auto called if the user tries to close the Dialog by pressing Escape or the Cross Icon
	 */
	public onDismiss(): void {
		this.onCancel();
	}
}
